import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import {
	Chip,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { formatDateTime } from "../../utils/date-formatting";

interface PersonTagHistoryProps {
	missingHistory: string[];
	tagHistory: Array<{
		id: number;
		name: string;
		action: string;
		username: string;
		timestamp: string;
	}>;
	updateFunc: (index: number, historyId: number, newValue: Date | null) => void;
	addTagAuditLog: (tagName: string, date: Date) => void;
}

export const PersonTagHistory = ({ tagHistory }: PersonTagHistoryProps) => {
	const theme = useTheme();

	const getActionIcon = (action: string) => {
		if (action === "removed") {
			return (
				<RemoveCircleIcon
					fontSize="small"
					sx={{ color: theme.palette.error.main }}
				/>
			);
		}
		return (
			<AddCircleIcon
				fontSize="small"
				sx={{ color: theme.palette.success.main }}
			/>
		);
	};

	return (
		<TableContainer data-component="tag-history-table">
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>Action</TableCell>
						<TableCell>Tag</TableCell>
						<TableCell>By</TableCell>
						<TableCell>Time</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{tagHistory.length === 0 ? (
						<TableRow>
							<TableCell colSpan={4} align="center">
								No history
							</TableCell>
						</TableRow>
					) : (
						tagHistory.map((hist) => (
							<TableRow key={hist.id} data-component="tag-history-row">
								<TableCell>{getActionIcon(hist.action)}</TableCell>
								<TableCell>
									<Chip label={hist.name} size="small" />
								</TableCell>
								<TableCell>{hist.username}</TableCell>
								<TableCell>{formatDateTime(hist.timestamp)}</TableCell>
							</TableRow>
						))
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
